import React, { FC } from 'react';
import { FormatChangeRequiredTabProps } from './FormatChangeRequiredTabProps';
import useTranslation from '../../hooks/useTranslation';
import ProjectNameInput from '../ProjectTab/ProjectNameInput';
import ProjectDatesFields from '../ProjectTab/ProjectDatesFields';
import SiteInfoSelects from '../SiteTab/SiteInfoFields/SiteInfoSelects';
import LocationInfoCountrySelect from '../SiteTab/LocationInfoCountrySelect';
import BUInput from '../SiteTab/BUInputs';
import ProjectCountryResponsible from '../ProjectCountryResponsible';
import ProjectConfidentialButton from '../ProjectTab/ProjectConfidentialButton';
import Text from '@ingka/text';
import ProjectTabImproveSolutions from '../ProjectTabImproveSolutions';
const FormatChangeRequiredTab: FC<FormatChangeRequiredTabProps> = ({
  countries,
  isConfidentialAllowed,
  usersList,
  onCountryChanged,
  BUList,
  onBUChange,
}) => {
  const t = useTranslation();
  return (
    <>
      <Text textStyle="Heading.S" tagName="h4">
        {t('labels.projectInformation')}
      </Text>
      <ProjectNameInput />
      <ProjectDatesFields openingDate />
      <LocationInfoCountrySelect
        countries={countries}
        onCountryChange={onCountryChanged}
      />
      <BUInput BuList={BUList} onBUChange={onBUChange} required />
      <SiteInfoSelects
        unitType
        transactionType
        newUnitType
        unitCategoryDisabled
      />
      <ProjectCountryResponsible usersList={usersList} required={true} />
      <Text textStyle="Heading.S" tagName="h4">
        Solutions
      </Text>
      <ProjectTabImproveSolutions />
      {isConfidentialAllowed && <ProjectConfidentialButton />}
    </>
  );
};

export default FormatChangeRequiredTab;
